module.exports = "<my-railway-create-form my-railway=\"$$railway.data.myRailway\"\n  enable-title=\"true\">\n</my-railway-create-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/railway/templates/new.html
// module id = 1517
// module chunks = 0